module.exports = __webpack_public_path__ + "static/zelt1-4623704a1076f5e303d761d972e6dcad.jpg";